var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfFile = function SvgPdfFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#D0D5DD",
    strokeWidth: 1.5,
    d: "M10.6.75h12q.065 0 .12.036l.032.027 8.635 8.634c.04.04.062.096.062.153V28a3.25 3.25 0 0 1-3.25 3.25H10.6A3.25 3.25 0 0 1 7.35 28V4A3.25 3.25 0 0 1 10.6.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D0D5DD",
    strokeWidth: 1.5,
    d: "M22.6.4v5.2a4 4 0 0 0 4 4h5.2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15,
    x: 0.199,
    y: 13.3,
    fill: "#D92D20",
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.948 24.3v-6.546h2.583q.745 0 1.268.285.525.28.8.783.278.498.278 1.15 0 .653-.282 1.151a1.94 1.94 0 0 1-.815.777q-.53.278-1.284.278H4.85v-1.11h1.422q.4 0 .658-.137a.9.9 0 0 0 .39-.387q.13-.249.131-.572a1.2 1.2 0 0 0-.13-.569.88.88 0 0 0-.39-.38q-.263-.137-.666-.137h-.933V24.3zm8.148 0h-2.32v-6.546h2.339q.987 0 1.7.393.712.39 1.096 1.122.387.732.387 1.752t-.387 1.758q-.383.735-1.102 1.128-.716.393-1.713.393m-.937-1.186h.88q.612 0 1.031-.217a1.4 1.4 0 0 0 .633-.681q.215-.463.215-1.195 0-.726-.215-1.186a1.4 1.4 0 0 0-.63-.678q-.418-.217-1.032-.217h-.882zm5.164 1.186v-6.546h4.334v1.141h-2.95v1.56h2.662v1.141h-2.662V24.3z"
  })));
};
export default SvgPdfFile;